import { translationsReducer } from './translationsReducer';
import { LOCALIZATION_NAMESPACE } from './constants';

export default {
  [LOCALIZATION_NAMESPACE]: translationsReducer,
};
